import Divider from '@material-ui/core/Divider';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
	divider: {
		margin: '20px',
	},
	header: {
		display: 'flex',
	},
	checkIcon: {
		fill: theme.palette.primary.main,
		position: 'relative',
		paddingLeft: '5px',
	},
});

const SectionDivider = ({ classes, hideDivider, title }) => (
	<div>
		{hideDivider ? null : <Divider className={classes.divider} />}
		<div className={classes.header}>
			<Typography type="title" color="primary" paragraph>
				{title}
			</Typography>
		</div>
	</div>
);

SectionDivider.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	hideDivider: PropTypes.bool,
	title: PropTypes.string.isRequired,
};

SectionDivider.defaultProps = {
	hideDivider: false,
};

export default withStyles(styles, { name: 'SectionDivider' })(SectionDivider);
